module.exports = {
  name: 'Hrshk',
  description: 'desc',
  routes: [
    {
      path: '',
      name: 'Головна',
      icon: 'fa-home',
      exact: true,
      inMenu: true,
      component: {
        name: 'Dashboard',
        props: {},
        routes: null
      }
    },
    {
      path: 'orders',
      name: 'Замовлення',
      icon: 'fa-tags',
      exact: false,
      inMenu: true,
      component: {
        name: 'Orders',
        props: {},
        routes: null
      }
    },
    {
      path: 'callback-form',
      name: 'Зворотній зв\'язок',
      icon: 'fa-tags',
      exact: false,
      inMenu: true,
      component: {
        name: 'CallbackForm',
        props: {},
        routes: null
      }
    },
    {
      path: 'categories',
      name: 'Категорії',
      icon: 'fa-tags',
      exact: false,
      inMenu: true,
      component: {
        name: 'Categories',
        props: {},
        routes: null
      }
    },
    {
      path: 'attributes',
      name: 'Атрибути',
      icon: 'fa-server',
      exact: false,
      inMenu: true,
      component: {
        name: 'Attributes',
        props: {},
        routes: null
      }
    },
    {
      path: 'products',
      name: ' Товари',
      icon: 'fa-cubes',
      exact: false,
      inMenu: true,
      component: {
        name: 'Products',
        props: {},
        routes: null
      }
    },
    {
      path: 'manufacturers',
      name: ' Виробники',
      icon: 'fa-cubes',
      exact: false,
      inMenu: true,
      component: {
        name: 'Manufacturers',
        props: {},
        routes: null
      }
    },
    {
      path: 'types',
      name: ' Типи',
      icon: 'fa-cubes',
      exact: false,
      inMenu: true,
      component: {
        name: 'Types',
        props: {},
        routes: null
      }
    },
    {
      path: 'articles',
      name: ' Статті',
      icon: 'fa-cubes',
      exact: false,
      inMenu: true,
      component: {
        name: 'Articles',
        props: {},
        routes: null
      }
    },
    {
      path: 'banners',
      name: ' Банери',
      icon: 'fa-image',
      exact: false,
      inMenu: true,
      component: {
        name: 'Banners',
        props: {},
        routes: null
      }
    },
    {
      path: 'solo-banner',
      name: 'Самотній банер',
      icon: 'fa-image',
      exact: false,
      inMenu: true,
      component: {
        name: 'SoloBanner',
        props: {},
        routes: null
      }
    },
    {
      path: 'contact',
      name: 'Контакти',
      icon: 'fa-map-marker',
      exact: false,
      inMenu: true,
      component: {
        name: 'Contact',
        props: {},
        routes: null
      }
    },
    {
      path: 'phones',
      name: 'Номери телефонів',
      icon: 'fa-phone',
      exact: false,
      inMenu: true,
      component: {
        name: 'Phones',
        props: {},
        routes: null
      }
    },
    {
      path: 'navs',
      name: 'Меню',
      icon: 'fa-bars',
      exact: false,
      inMenu: true,
      component: {
        name: 'Navs',
        props: {},
        routes: null
      }
    },
    {
      path: 'links',
      name: ' Посилання',
      icon: 'fa-link',
      exact: false,
      inMenu: true,
      component: {
        name: 'Links',
        props: {},
        routes: null
      }
    },
    {
      path: 'exchange',
      name: ' Курс',
      icon: 'fa-credit-card',
      exact: false,
      inMenu: true,
      component: {
        name: 'Exchange',
        props: {},
        routes: null
      }
    },
    // {
    //   path: '/orders',
    //   exact: false,
    //   component: {
    //     name: 'Orders',
    //     props: {},
    //     routes: null
    //   }
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/structure.js